import { useEffect } from "react";
import { useSelector } from "react-redux";
import { getLoggedUser } from "~/store/selectors/selector.users";
import Security from "../../security";

export const useSecurity = () => {
  const loggedUser = useSelector(getLoggedUser);
  Security.setUser(loggedUser); //set user when is first called
  useEffect(() => {
    Security.setUser(loggedUser); //set user when is changed from redux
  }, [loggedUser]);

  return Security.decide;
};
